import { BaseModel } from '@/api/base-model'
import { PrintedDocumentAPI } from '@/api/backend-client'
import { Company } from '@/api/model/company'

export class PrintedDocument extends BaseModel<PrintedDocument> {
    protected collectionName = PrintedDocumentAPI.collectionName

    constructor(
        public company: Company|null,
        public id: string,
        public documentId: string,
        public documentName: string,
        public documentDescription: string,
        public productId: string,
        public shippingCompanyName: string,
        public shippingName: string,
        public shippingStreetname: string,
        public shippingStreetnumber: string,
        public shippingStreetnumbersuffix: string,
        public shippingZipcode: string,
        public shippingCity: string,
        public shippingCountry: string,
        public status: string,
        public trackingUrl: string,
        public createdAt: Date,
        public updatedAt: Date,
    ) { super(id) }

    static fromData(data: any): PrintedDocument {
        if (data === null || typeof data === 'string' || data instanceof PrintedDocument) {
            return data
        }

        return new PrintedDocument(
            data.company ? Company.fromData(data.company) : null,
            data.id,
            data.documentId,
            data.documentName,
            data.documentDescription,
            data.productId,
            data.shippingCompanyName,
            data.shippingName,
            data.shippingStreetname,
            data.shippingStreetnumber,
            data.shippingStreetnumbersuffix,
            data.shippingZipcode,
            data.shippingCity,
            data.shippingCountry,
            data.status,
            data.trackingUrl,
            data.createdAt,
            data.updatedAt,
        )
    }
}
